import { render, staticRenderFns } from "./supplierContactChangeInvitationsHandler.vue?vue&type=template&id=624388c0&"
import script from "./supplierContactChangeInvitationsHandler.vue?vue&type=script&lang=js&"
export * from "./supplierContactChangeInvitationsHandler.vue?vue&type=script&lang=js&"
import style0 from "./supplierContactChangeInvitationsHandler.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports